<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ modalTile }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <app-input
            [formControl]="slotForm.controls.name"
            [showErrors]="showValidations"
            [placeholder]="'admin.lifts.slotModal.name' | translate"
            label="{{ 'admin.lifts.slotModal.name' | translate }}">
        </app-input>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="primary" class="create"
                    [disabled]="isLoading"
                    (click)="onSaveSlot()">
            {{ 'admin.lifts.slotModal.button' | translate }}
        </app-button>
    </div>
</app-modal>
